
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">Unsupported Type: {{entityType()}}</div>
          <div class="card-body"><pre>{{defaultJson() | json}}</pre></div>
        </div>
      </div>
    </div>
    